module.exports = __webpack_public_path__ + "Images/layout_white.png";


//////////////////
// WEBPACK FOOTER
// ./Images/layout_white.png
// module id = 807
// module chunks = 2